// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"49":"dad4dfee","185":"196144ea","455":"c7852015","585":"6cbbdfe5","709":"5bc9483d"}[chunkId] + ".chunk.js";
};